import { render, staticRenderFns } from "./BasketItem.vue?vue&type=template&id=45c49514&"
import script from "./BasketItem.vue?vue&type=script&lang=js&"
export * from "./BasketItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/unnamed777/projects/zetton.ru/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45c49514')) {
      api.createRecord('45c49514', component.options)
    } else {
      api.reload('45c49514', component.options)
    }
    module.hot.accept("./BasketItem.vue?vue&type=template&id=45c49514&", function () {
      api.rerender('45c49514', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/BasketItem.vue"
export default component.exports